
















































import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import {calculateMinutesFromDate, Dialog, engine, getStationName, MyTrainInfo, showDialog} from '@/data/train-store';
import TrainRideLine from './TrainRideLine.vue';
import {Observer} from 'mobx-vue';
import {computed} from '@/lib/computed';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import {GTag} from '@/lib/google-analytics';

@Observer
@Component({
  components: {TrainRideLine, LoadingOverlay}
})
export default class MyTrainItem extends Vue {
  @Prop(Object) public train!: MyTrainInfo;
  @Inject('$gtag') public readonly $gtag!: GTag;
  private updateError = '';
  private intervalRef?: number;
  private now = new Date();

  private menuItems = [
    {
      title: 'שנה שם',
      icon: 'edit',
      action: 'rename'
    },
    {
      title: 'מחק',
      icon: 'delete',
      action: 'delete'
    }
  ];

  @computed get isStale() {
    return (this.now.getTime() - this.train.updatedTime) > (1000 * 60 * 60);
  }

  @computed get name() {
    return this.train.name
      || `<span>${getStationName(this.train.fromId)}</span>` + ` ← ` +
      `<span>${getStationName(this.train.toId)}</span>`;
  }

  @computed get nowRides() {
    return this.train.nowRides.filter((ride) => calculateMinutesFromDate(ride) < 10).slice(0, 20);
  }

  public created() {
    this.intervalRef = setInterval(() => {
      this.now = new Date();
    }, 60000);
  }

  public destroyed() {
    clearInterval(this.intervalRef);
  }

  private onItemClick(item: any) {
    if (item.action === 'rename') {
      showDialog(Dialog.TRAIN_RENAME, (newName: string) => {
        if (newName) {
          engine.renameTrain(this.train.id, newName);
          this.$gtag.trackEvent('rename-train', 0, this.train.id);
        } else {
          this.$gtag.trackEvent('rename-train', 0, 'dismissed');
        }
      });
    } else if (item.action === 'delete') {
      engine.removeTrain(this.train.id);
      this.$gtag.trackEvent('delete-train', 0, this.train.id);
    }
  }

  private onRefreshClick() {
    this.updateError = '';
    const start = Date.now();
    engine.updateTrainData(this.train)
      .then(
        (updated) => {
          if (updated) {
            this.$gtag.trackEvent('train-update-success', Date.now() - start);
          }
        },
        (err) => {
          this.$gtag.trackEvent('train-update-error', Date.now() - start, '', err.message);
          this.updateError = 'העדכון נכשל, נסה שנית?';
          console.error(err);
        }
      );
  }
}
